const common_es = require('./common.json')
export default common_es